import { render, staticRenderFns } from "./OverdueJobs.vue?vue&type=template&id=52596c2a&"
import script from "./OverdueJobs.vue?vue&type=script&lang=js&"
export * from "./OverdueJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports